
/* injects from baggage-loader */

'use strict';

import $ from 'jquery';

export default class DialogConfirmAvatarController {
    constructor($log, $element, $timeout) {
        'ngInject';
        this.$log = $log;
        this.$element = $element;
        this.$timeout = $timeout;
    }

    ok(){
      this.modalInstance.close(true);
    }

    cancel(){
      this.modalInstance.dismiss('cancel');
    }

    $onInit(){
      this.$timeout(this.setAvatarBackground.bind(this, this.resolve.indexOf));
    }

    setAvatarBackground(indexOf){
      let avatarClass = `avatar-${indexOf + 1}`;
      return $(this.$element).closest('.modal-dialog').addClass(avatarClass);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/confirm-avatar/confirm-avatar.controller.js